import { fetchRoutesForUser, fetchChildUsers } from './userAction';
import { getReportTypes } from './reportAction';
import { getMessages, getFileTypes } from './messagesAction';
import { getAddressesForUser } from './addressAction'
/*
	Dispatches all actions to refresh necessary data.
*/
export const megaDispatch = (clientPath, user_id, user_token, showEditProgress = true, selectedRepresentativeUserId) =>
{	

	return (dispatch) => {

		dispatch(fetchRoutesForUser(clientPath + '/api/user/action/getRoutes', user_id, user_token, showEditProgress, selectedRepresentativeUserId))		
		dispatch(getMessages(clientPath + '/api/messages/action/getMessages', user_id, user_token, showEditProgress, selectedRepresentativeUserId))
		dispatch(getReportTypes(clientPath + '/api/reports/action/getReportTypes', user_id, showEditProgress, selectedRepresentativeUserId))
		dispatch(fetchChildUsers(clientPath + '/api/user/action/getChildUsers', user_id, showEditProgress, selectedRepresentativeUserId))
		dispatch(getAddressesForUser(clientPath + '/api/addresses/action/forUser', user_id, showEditProgress, selectedRepresentativeUserId));
		dispatch(getFileTypes(clientPath + '/api/messages/action/getFiltersForFileType'))
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/megaDispatch.js